import { render, staticRenderFns } from "./JustificativaCartao.vue?vue&type=template&id=39194705&scoped=true"
import script from "./JustificativaCartao.vue?vue&type=script&setup=true&lang=js"
export * from "./JustificativaCartao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JustificativaCartao.vue?vue&type=style&index=0&id=39194705&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39194705",
  null
  
)

export default component.exports